import React from 'react'
import { IconsProps } from 'msp-integrations'

const MailIcon = (props: IconsProps) => {
  return (
    <svg {...props} viewBox='0 0 23 17' xmlns='http://www.w3.org/2000/svg'>
      <path d="M3.038.869A2.569 2.569 0 0 0 .473 3.434v13.258h19.663a2.569 2.569 0 0 0 2.565-2.565V.869H3.038Zm18.153.803L11.6 9.326 2.24 1.875c.24-.124.51-.2.798-.2h18.153v-.003Zm-1.055 14.219H1.276V3.436c0-.385.13-.739.34-1.03l9.985 7.948 10.296-8.218v11.99c0 .974-.79 1.765-1.76 1.765Z"/>
    </svg>
  )
}

export default MailIcon
